<div class="modal-body" align="left">
  <h4 class="primary">
    <b>Comprobante de pago</b>
  </h4>
  <hr />

  <div *ngIf="receipt" class="row row-detail">
    <div class="col-md-6">
      <div class="row">
        <div class="col col-md-6">
          <b>Banco emisor</b>
        </div>
        <div class="col col-md-6">
          {{ receipt.issuingBank | titlecase }}
        </div>
      </div>
      <div class="row">
        <div class="col col-md-6">
          <b>Nº de cuenta banco emisor</b>
        </div>
        <div class="col col-md-6">
          {{ receipt.issuingBankNumber }}
        </div>
      </div>
      <div class="row">
        <div class="col col-md-6">
          <b>Banco receptor</b>
        </div>
        <div class="col col-md-6">
          {{ receipt.receivingBank | titlecase }}
        </div>
      </div>
      <div class="row">
        <div class="col col-md-6">
          <b>Fecha transferencia</b>
        </div>
        <div class="col col-md-6">
          {{ receipt.transferDate | date: "dd/MM/yyyy" }}
        </div>
      </div>
    </div>
    <div class="col-md-6">
      <div class="row">
        <div class="col col-md-6">
          <b>Monto</b>
        </div>
        <div class="col col-md-6">
          {{ receipt.amount | currency:'':'' | customCurrency: receipt.currency }}
        </div>
      </div>
      <div class="row">
        <div class="col col-md-6">
          <b>Moneda</b>
        </div>
        <div class="col col-md-6">
          {{ receipt.currency }}
        </div>
      </div>
      <div class="row">
        <div class="col col-md-6">
          <b>Nº de operación</b>
        </div>
        <div class="col col-md-6">
          {{ receipt.operationNumber }}
        </div>
      </div>
    </div>
  </div>

  <app-loading [padding]="200" *ngIf="loading"></app-loading>
  <app-no-results *ngIf="!loading && error"></app-no-results>
  <div class="animated fadeIn" *ngIf="!loading && url && !error">
    <ngx-extended-pdf-viewer
      [src]="url"
      useBrowserLocale="true"
      height="80vh"
      [showToolbar]="true"
      [showBorders]="false"
      [showFindButton]="false"
      [backgroundColor]="'white'"
    ></ngx-extended-pdf-viewer>
  </div>
  <div class="row text-center" *ngIf="!loading">
    <button
      (click)="hide()"
      class="button-continue button-find-label"
    >
      Cerrar
    </button>
  </div>
  
</div>
